import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

interface FeedbackModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  buttonText?: string;
  type?: 'success' | 'error';
}

const FeedbackModal: React.FC<FeedbackModalProps> = ({ open, onClose, title, message, buttonText = 'Cerrar', type = 'success' }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth aria-labelledby="feedback-modal-title" aria-describedby="feedback-modal-message">
      <DialogTitle id="feedback-modal-title" sx={{ textAlign: 'center', pt: 4 }}>
        <img src="/Logo de la página.png" alt="Green Balance Logo" style={{ width: 80, height: 80, margin: '0 auto', display: 'block' }} />
        <Typography variant="h5" fontWeight={700} color={type === 'error' ? 'error' : 'primary'} mt={2} mb={1}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ textAlign: 'center', pb: 2 }}>
        <Typography variant="body1" color="text.primary" id="feedback-modal-message">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button onClick={onClose} color={type === 'error' ? 'error' : 'primary'} variant="contained" size="large" sx={{ borderRadius: 999, px: 5, fontWeight: 700 }} autoFocus>
          {buttonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FeedbackModal; 